import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { InjectGlobalStyles } from "./components/InjectGlobalStyles";
import { Pages } from "./pages";
import store from "./store";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(_jsx(Provider, { store: store, children: _jsx(BrowserRouter, { basename: process.env.APP_PATH, children: _jsx(InjectGlobalStyles, { children: _jsx(Pages, {}) }) }) }));
